const PRIVILEGE_ADMIN = 'P_A_ROLE';
const PRIVILEGE_USER = 'P_USER';

export {
    PRIVILEGE_ADMIN,
    PRIVILEGE_USER
};

